import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TagEmailInputComponent } from '@app/components/_shared/tag-email-input/tag-email-input.component';
import { ThumbsComponent } from '@app/components/_shared/thumbs/thumbs.component';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { TagInputModule } from 'ngx-chips';
import { HeartButtonComponent } from '@app/shared/components/buttons/heart-button/heart-button.component';
import { RoundButtonComponent } from '@app/shared/components/buttons/round-button/round-button.component';
import { TickButtonComponent } from '@app/shared/components/buttons/tick-button/tick-button.component';
import { ConnectionErrorComponent } from '@app/shared/components/connection-error/connection-error.component';
import { DoughnutChartComponent } from '@app/shared/components/doughnut-chart/doughnut-chart.component';
import { DropdownComponent } from '@app/shared/components/dropdown/dropdown.component';
import { OpenDayListComponent } from '@app/shared/components/open-day-list/open-day-list.component';
import { ReadMoreComponent } from '@app/shared/components/read-more/read-more.component';
import { StarRatingComponent } from '@app/shared/components/star-rating/star-rating.component';
import { OrderByPipe } from '@app/shared/pipes/order-by.pipe';
import { ParseFormattedTextPipe } from '@app/shared/pipes/parse-formatted-text.pipe';
import { StringFormatPipe } from '@app/shared/pipes/string-format.pipe';

const ToDeclareAndExport = [
  TickButtonComponent,
  StarRatingComponent,
  OpenDayListComponent,
  DoughnutChartComponent,
  ReadMoreComponent,
  DropdownComponent,
  HeartButtonComponent,
  RoundButtonComponent,
  ConnectionErrorComponent,

  ParseFormattedTextPipe,
  StringFormatPipe,
  OrderByPipe,
  ThumbsComponent,
  TagEmailInputComponent
];

@NgModule({
  imports: [CommonModule, FormsModule, ChartsModule, TagInputModule],
  declarations: ToDeclareAndExport,
  exports: ToDeclareAndExport
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts